/**
 * Validates email format using a standard regex pattern
 */
export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
/**
 * Validates name format - allows letters, spaces, hyphens, apostrophes, and periods
 * Must contain at least one letter
 */
export const validateName = (name) => {
    const nameRegex = /^[a-zA-Z\s\-'\.]+$/;
    const hasLetter = /[a-zA-Z]/.test(name.trim());
    return name.trim().length >= 1 && nameRegex.test(name.trim()) && hasLetter;
};
/**
 * Validates OTP code - must be exactly 6 digits
 */
export const validateOTPCode = (code) => {
    return code.length === 6 && /^\d{6}$/.test(code);
};
/**
 * Checks if OTP code contains only digits
 */
export const isOTPCodeNumeric = (code) => {
    return !/[^\d]/.test(code);
};
